/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { invoiceBreakdown } from '../../axios/invoiceBreakdown'
import type {
	InvoiceBreakdownError,
	InvoiceBreakdownPathParams,
	InvoiceBreakdownResponse,
} from '../../types/InvoiceBreakdown'

export const invoiceBreakdownQueryKey = (
	organisation: InvoiceBreakdownPathParams['organisation'],
	invoice: InvoiceBreakdownPathParams['invoice'],
) => [{ url: '/:organisation/invoices/:invoice/breakdown', params: { organisation, invoice } }] as const

export type InvoiceBreakdownQueryKey = ReturnType<typeof invoiceBreakdownQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::breakdown */
export function invoiceBreakdownQueryOptions(
	organisation: InvoiceBreakdownPathParams['organisation'],
	invoice: InvoiceBreakdownPathParams['invoice'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		InvoiceBreakdownResponse,
		AxiosError<InvoiceBreakdownError>,
		InvoiceBreakdownResponse,
		InvoiceBreakdownQueryKey
	>({
		queryKey: invoiceBreakdownQueryKey(organisation, invoice),
		queryFn: ({ signal }) => invoiceBreakdown(organisation, invoice, { signal, ...config }).then(res => res.data),
		enabled: !!(organisation && invoice),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::breakdown */
export function useInvoiceBreakdown<TSelectData = InvoiceBreakdownResponse>(
	organisation: InvoiceBreakdownPathParams['organisation'],
	invoice: InvoiceBreakdownPathParams['invoice'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					InvoiceBreakdownResponse,
					AxiosError<InvoiceBreakdownError>,
					TSelectData,
					InvoiceBreakdownQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<InvoiceBreakdownError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...invoiceBreakdownQueryOptions(organisation, invoice),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::breakdown */
export function useInvoiceBreakdownSuspense<TSelectData = InvoiceBreakdownResponse>(
	organisation: InvoiceBreakdownPathParams['organisation'],
	invoice: InvoiceBreakdownPathParams['invoice'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					InvoiceBreakdownResponse,
					AxiosError<InvoiceBreakdownError>,
					TSelectData,
					InvoiceBreakdownQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<InvoiceBreakdownError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...invoiceBreakdownQueryOptions(organisation, invoice),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
